import axios from "axios";


export default {
  getAllStatusi() {
    try {
      return axios.get("https://app-psod.cratis.cloud/api/osoba/statusi");
    } catch (err) {
      console.log(err);
    }
  },

  getLegBodyStatusi() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sluzbena-uloga");
    } catch (err) {
      console.log(err);
    }
  }

}